var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['nut-backtop', { show: _vm.backTop }],style:(_vm.styles),on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_vm._t("default",[_c('div',{staticClass:"nut-backtop-main"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }